var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-internal-section width-full float-l" },
    [
      _c(
        "div",
        { staticClass: "container" },
        [
          _vm.cantAccessPage === true
            ? [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    {
                      staticClass: "col-12 col-sm-12 col-md-4 col-lg-4 col-lg-4"
                    },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "header-section col-12 float-l bgcolor-cfe3ee"
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "back-btn-chat float-l" },
                              [
                                _c(
                                  "router-link",
                                  { attrs: { to: { name: "CustomerList" } } },
                                  [
                                    _c("i", {
                                      staticClass: "hi-icon icon-chatback"
                                    })
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "customer-name float-l colpie-87"
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "color-231f20 font-roboto-bold heading-text-16 line-height-20 agent-customer-name float-l width-full pt_10 pl_40 mb_0"
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.customerDetails.name) +
                                        " (Customer Name)\n                                "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "menu-right-header float-r" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "nc-chat-right-dropdown" },
                                  [
                                    _c("div", { staticClass: "dropdown" }, [
                                      _vm._m(0),
                                      _vm._v(" "),
                                      _c(
                                        "ul",
                                        { staticClass: "dropdown-menu" },
                                        [
                                          _vm._m(1),
                                          _vm._v(" "),
                                          _c(
                                            "li",
                                            [
                                              _c(
                                                "router-link",
                                                {
                                                  attrs: {
                                                    to: { name: "UserList" }
                                                  }
                                                },
                                                [
                                                  _vm._v(" User List "),
                                                  _c("span", [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-angle-right custom"
                                                    })
                                                  ])
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "li",
                                            [
                                              _c(
                                                "router-link",
                                                {
                                                  attrs: {
                                                    to: { name: "CustomerList" }
                                                  }
                                                },
                                                [
                                                  _vm._v(" Customer List "),
                                                  _c("span", [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-angle-right custom"
                                                    })
                                                  ])
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "li",
                                            [
                                              _c(
                                                "router-link",
                                                {
                                                  attrs: {
                                                    to: { name: "ArchivedChat" }
                                                  }
                                                },
                                                [
                                                  _vm._v(" Archived Chat "),
                                                  _c("span", [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-angle-right custom"
                                                    })
                                                  ])
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("li", [
                                            _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href: "javascript:void(0)"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.logoutMobileViewCustomerDetailsSide(
                                                      $event
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v(" Sign Out "), _vm._m(2)]
                                            )
                                          ])
                                        ]
                                      )
                                    ])
                                  ]
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "chat-btm-section-main add-user-main-section width-full float-l"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "add-user-form update-user-top-section customer-detail-form col-12 float-l mt_10 "
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "form-group float-l width-full p_15"
                                  },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"
                                      },
                                      [_vm._v(" Email ")]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      staticClass: "form-control custom-select",
                                      attrs: {
                                        type: "text",
                                        placeholder: _vm.customerDetails.email,
                                        disabled: ""
                                      }
                                    }),
                                    _vm._v(" "),
                                    _vm._m(3)
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "form-group float-l width-full p_15"
                                  },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"
                                      },
                                      [_vm._v(" Phone ")]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      staticClass: "form-control custom-select",
                                      attrs: {
                                        type: "text",
                                        placeholder: _vm.customerDetails.phone,
                                        disabled: ""
                                      }
                                    }),
                                    _vm._v(" "),
                                    _vm._m(4)
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "form-group float-l width-full p_15"
                                  },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"
                                      },
                                      [_vm._v(" Created Date & Time ")]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      staticClass: "form-control custom-select",
                                      attrs: {
                                        type: "text",
                                        placeholder: _vm.customerDetails.date,
                                        disabled: ""
                                      }
                                    }),
                                    _vm._v(" "),
                                    _vm._m(5)
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "form-group float-l width-full p_15"
                                  },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"
                                      },
                                      [_vm._v(" Section ")]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      staticClass: "form-control custom-select",
                                      attrs: {
                                        type: "text",
                                        placeholder:
                                          _vm.customerDetails.sections,
                                        disabled: ""
                                      }
                                    }),
                                    _vm._v(" "),
                                    _vm._m(6)
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    ]
                  )
                ])
              ]
            : [_vm.isRequestComplete ? [_vm._m(7)] : _vm._e()]
        ],
        2
      ),
      _vm._v(" "),
      _c("app-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "more-btn btn btn-primary dropdown-toggle",
        attrs: { type: "button", "data-toggle": "dropdown" }
      },
      [
        _c("span", { staticClass: "more-dot" }),
        _vm._v(" "),
        _c("span", { staticClass: "more-dot" }),
        _vm._v(" "),
        _c("span", { staticClass: "more-dot" })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("a", { attrs: { href: "site-list.html" } }, [
        _vm._v(" My Sites "),
        _c("span", [_c("i", { staticClass: "fa fa-angle-right custom" })])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", { staticClass: "fa fa-angle-right custom" })])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", { staticClass: "hi-icon icon-chatemail" })])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", { staticClass: "hi-icon icon-chatphone-call" })])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", { staticClass: "hi-icon icon-chatcalendar-1" })])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("i", { staticClass: "hi-icon icon-chatdelivery-truck" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("div", { staticClass: "error-template" }, [
        _c("h1", [_vm._v("\n                            Oops!")]),
        _vm._v(" "),
        _c("h2", [_vm._v("\n                            403 ")]),
        _vm._v(" "),
        _c("div", { staticClass: "error-details" }, [
          _vm._v(
            "\n                            Sorry!, You don't have permission to access this page.\n                        "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c472ae3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c472ae3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Customer/CustomerDetails.vue
// module id = null
// module chunks = 